import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { ADDRESS_COUNTRIES, countryLabelKey } from "@/shared/utils/addressCountry";
export function useAddressCountryOptions() {
    const { t } = useI18n();
    return computed(() => ADDRESS_COUNTRIES.map((c) => ({ value: c.value, label: t(countryLabelKey(c.labelKey)) })));
}
